import { __assign, __decorate, __extends, __metadata, __rest } from "tslib";
import React from 'react';
import { Utils } from '@singularsystems/neo-core';
import { makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import { FileContext } from './FileContext';
var FileDropArea = /** @class */ (function (_super) {
    __extends(FileDropArea, _super);
    function FileDropArea(props) {
        var _this = _super.call(this, props) || this;
        _this.isDragging = false;
        _this.dropDiv = React.createRef();
        makeObservable(_this);
        return _this;
    }
    FileDropArea.prototype.dragEnter = function (e) {
        e.preventDefault();
        this.isDragging = true;
    };
    FileDropArea.prototype.dragLeave = function (e) {
        if (e.target === this.dropDiv.current && (!e.relatedTarget || !e.target.contains(e.relatedTarget))) {
            e.preventDefault();
            this.isDragging = false;
        }
    };
    FileDropArea.prototype.drop = function (e) {
        this.isDragging = false;
        e.preventDefault();
        if (!this.fileManager.isUploading) {
            var files = void 0;
            if (e.dataTransfer.items) {
                files = Array.from(e.dataTransfer.items).filter(function (item) { return item.kind === "file"; }).map(function (file) { return file.getAsFile(); });
            }
            else {
                files = e.dataTransfer.files;
            }
            this.fileManager.processFiles(files, { handleErrors: true });
        }
    };
    FileDropArea.prototype.render = function () {
        var _this = this;
        var _a = this.props, fileManager = _a.fileManager, nativeProps = __rest(_a, ["fileManager"]);
        if (this.context.fileManager) {
            this.fileManager = this.context.fileManager;
        }
        else {
            if (!fileManager) {
                throw Error("File drop area must be in a FileContext, or have fileManager specified.");
            }
            this.fileManager = fileManager;
        }
        nativeProps.className = Utils.joinWithSpaces(nativeProps.className, "neo-file-drop", this.isDragging ? "dragging" : "");
        return (React.createElement("div", __assign({}, nativeProps, { ref: this.dropDiv, onDrop: function (e) { return _this.drop(e); }, onDragEnter: function (e) { return _this.dragEnter(e); }, onDragLeave: function (e) { return _this.dragLeave(e); }, onDragOver: function (e) { return e.preventDefault(); } })));
    };
    FileDropArea.contextType = FileContext;
    __decorate([
        observable.ref,
        __metadata("design:type", Object)
    ], FileDropArea.prototype, "isDragging", void 0);
    FileDropArea = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], FileDropArea);
    return FileDropArea;
}(React.Component));
export default FileDropArea;
